<template>
  <v-btn :icon="themeIcon" @click="toggleTheme" :title="themeTitle" />
</template>

<script setup>
import { useTheme } from 'vuetify'
import { computed, onMounted } from 'vue'

const theme = useTheme()
const THEME_KEY = 'xfm-theme' // můžeš libovolně přejmenovat

const isDark = computed(() => {
  const current = theme.global?.current?.value
  return current ? current.dark : false
})

const themeIcon = computed(() =>
  isDark.value ? 'mdi-white-balance-sunny' : 'mdi-weather-night'
)

const themeTitle = computed(() =>
  isDark.value ? 'Přepnout na světlý motiv' : 'Přepnout na tmavý motiv'
)

function toggleTheme() {
  const current = theme.global?.current?.value
  const name = theme.global?.name

  if (!current || !name) {
    console.warn('Motiv není plně dostupný.')
    return
  }

  const newTheme = current.dark ? 'light' : 'dark'
  name.value = newTheme
  localStorage.setItem(THEME_KEY, newTheme)
}

// 💡 nastav motiv podle uložené hodnoty hned po připojení komponenty
onMounted(() => {
  const savedTheme = localStorage.getItem(THEME_KEY)
  if (savedTheme === 'light' || savedTheme === 'dark') {
    theme.global.name.value = savedTheme
  }
})
</script>